import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
import { cn } from '@morpho-org/ui-v6/utils';
export interface CardDashboardLoadingProps {
  isExpanded?: boolean;
  isSmallDashboard?: boolean;
}

// md:-gated, not useIsMobile: this SSRs (route loading.tsx + Suspense passes),
// and a JS breakpoint branch layout-shifts on mobile at hydration.
const CardDashboardLoading = t0 => {
  const $ = _c(13);
  const {
    isExpanded,
    isSmallDashboard
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="gap-xs flex flex-col"><Skeleton className="h-md max-md:h-lg w-[90px] rounded-[20px] max-md:w-[54px]" /><Skeleton className="h-[52.8px] w-[140px] rounded-[20px] max-md:h-[44px]" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isExpanded || $[2] !== isSmallDashboard) {
    t2 = !isExpanded && !isSmallDashboard && <div className="max-lg:hidden"><Skeleton className="h-[90px] w-[251px] rounded-[20px]" /></div>;
    $[1] = isExpanded;
    $[2] = isSmallDashboard;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="flex items-center justify-between">{t1}{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = isSmallDashboard ? "h-[292px]" : "h-[288px]";
  let t5;
  if ($[6] !== t4) {
    t5 = cn("rounded-[20px] max-md:h-[200px]", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <Skeleton className={t5} />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <div className="gap-lg flex h-[100%] w-[100%] flex-[1px] flex-col">{t3}{t6}</div>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export default CardDashboardLoading;